<template>
  <div
    class="book_surgery toggleContainer desk_inner_width"
    :class="{ active: isOpen }"
    ref="selected_surgery"
  >
    <a
      class="book_surgery_top flex"
      href="javascript:void(0)"
      @click="isOpen = !isOpen"
    >
      <span class="title flex is--fit desk-flex--between">
        פרטי ניתוח מתוכנן (או מס׳ פעולות לניתוח)**

        <Tags :isRequired="true" />
      </span>
      <span class="plus-wrap flex m-flex--center">
        <span class="plus"></span>
      </span>
    </a>
    <div
      v-show="isOpen"
      class="book_surgery_open toggleInner surg-info-container"
      :class="{ disabled: isInsuranceRowsLoading }"
    >
      <div class="no_mobile surg_list_head desk-flex">
        <div class="surg_list-1">ניתוח ראשי</div>
        <div class="surg_list-2">צד</div>
        <!-- <div class="surg_list-2">תחום</div> -->
        <div class="surg_list-3">שם/קוד ניתוח (בי״ח)*</div>
        <div class="surg_list-4">שם/קוד ניתוח (קליני ICD9)*</div>
        <div class="surg_list-5">
          זמן הניתוח מהכניסה עד היציאה מהחדר*
        </div>
      </div>
      <SelectedSurgeryInfo
        :surgery_categories="surgery_categories"
        :rows="surgery.selected_surgery"
        :payment_token="surgery.payment_token"
        @editSelectedBlock="editSelectedBlock"
        @removeSelectedBlock="removeSelectedBlock"
      />
      <div
        v-show="!surgery.payment_token"
        class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top surg-info-container"
      >
        <div class="add_new_row flex surg_list-1">
          <div class="add_new_row_col1 desk-hide">ניתוח ראשי</div>
          <div class="add_new_row_col2">
            <span
              class="surgery-check flex"
              :class="{
                active: surg_info.is_primary == 'primary'
              }"
              @click.stop="onPrimary"
            >
              <span class="surgery-check-ic block"></span>
            </span>
          </div>
        </div>
        <div class="add_new_row flex surg_list-2">
          <div class="add_new_row_col1 desk-hide">צד</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block">
              <select2
                ref="surgerySideSelect"
                dir="rtl"
                v-model="surg_info.side"
              >
                <option value="">בחר צד</option>
                <option value="Right">Right</option>
                <option value="BIL">BIL</option>
                <option value="Left">Left</option>
              </select2>
            </div>
          </div>
        </div>
        <!-- <div class="add_new_row flex surg_list-2">
                    <div class="add_new_row_col1 desk-hide">תחום</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2 name="" dir="rtl" v-model="surg_info.category">
                          <option value="">בחר תחום</option>
                          <option
                            :value="row.current_surgery_category_code"
                            v-for="(row, index) in surgery_categories"
                            :key="
                              index + '-' + row.current_surgery_category_name
                            "
                          >
                            {{ row.current_surgery_category_name }}
                          </option>
                        </select2>
                      </div>
                    </div>
                  </div> -->
        <div class="add_new_row flex surg_list-3">
          <div class="add_new_row_col1 desk-hide">
            שם/קוד ניתוח (בי״ח)*
          </div>
          <div class="add_new_row_col2">
            <div
              class="input-opacity relative"
              :class="
                surg_info.code_name_hospital &&
                isEnglish(surg_info.code_name_hospital)
                  ? 'left-multiselect'
                  : 'right-multiselect'
              "
            >
              <div
                v-show="
                  surg_info.code_name_hospital !== '' &&
                    !disabledByAutocomplete.hospital
                "
                @click="resetValue('code_name_hospital')"
                class="surg-clear-btn"
                :class="{ 'btn-mobile': isMobile }"
                style="background: #f5f5f5"
              >
                X
              </div>
              <multiselect
                placeholder="בחר/הקלד שם/קוד ניתוח"
                v-model="surg_info.code_name_hospital"
                @search-change="onSearch($event, 'current_surgery')"
                @close="onSearch('', 'current_surgery')"
                :options="filteredHospitalCodes"
                :searchable="true"
                :internal-search="false"
                :disabled="
                  !surgery_codes?.length ||
                    disabledByAutocomplete.hospital ||
                    (surg_info.code_name_hospital !== '' &&
                      !disabledByAutocomplete.hospital)
                "
                :allow-empty="false"
                :options-limit="limit.current_surgery"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-4">
          <div class="add_new_row_col1 desk-hide">
            שם/קוד ניתוח<br />
            (קליני ICD9)*
          </div>
          <div class="add_new_row_col2">
            <div
              class="input-opacity relative"
              :class="
                surg_info.code_name_clinical &&
                isEnglish(surg_info.code_name_clinical)
                  ? 'left-multiselect'
                  : 'right-multiselect'
              "
            >
              <div
                v-show="
                  surg_info.code_name_clinical !== '' &&
                    !disabledByAutocomplete.clinical
                "
                @click="resetValue('code_name_clinical')"
                class="surg-clear-btn"
                :class="{ 'btn-mobile': isMobile }"
              >
                X
              </div>
              <multiselect
                placeholder="בחר/הקלד שם/קוד ניתוח קליני"
                v-model="surg_info.code_name_clinical"
                @search-change="onSearch($event, 'current_procedure')"
                @close="onSearch('', 'current_procedure')"
                :options="filteredClinicalCodes"
                :searchable="true"
                :internal-search="false"
                :disabled="
                  !surgery_codes_clinic?.length ||
                    disabledByAutocomplete.clinical
                "
                :allow-empty="false"
                :options-limit="limit.current_procedure"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-5">
          <div class="add_new_row_col1 desk-hide">
            זמן הניתוח מהכניסה עד היציאה מהחדר*
          </div>
          <div class="add_new_row_col2">
            <div class="input-opacity surg-time">
              <validation-provider
                ref="end_time"
                name="end_time"
                :rules="{
                  requiredSurgTime: [surg_info.code_name_hospital],
                  timeFormat: [null],
                  interval: [null]
                }"
                v-slot="{ errors }"
              >
                <cleave
                  :value="surg_info.duration"
                  :options="options"
                  @input="onCleave"
                  @focus.native="e => e.target.select()"
                  name="time"
                ></cleave>
                <span class="error-message">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>
        <ActionsMsgRow
          :errMsg="{ show: showErrorMessage, msg: errorMessage }"
          :isOnEdit="editRowIndex !== null"
          :isSurgInfo="true"
          @addBlock="addBlock"
          @removeSelectedBlock="clearEditRow"
        />
      </div>
      <span
        v-show="surgery.payment_token"
        class="surg-side-note text--20"
        style="margin-top: 6px;"
      >
        בוצע חיוב ונפתח תיק מטופל.<br />
        לא ניתן לערוך לעזרה יש ליצור קשר עם מוקד חדר ניתוח
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import Tags from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/Tags.vue";
import SelectedSurgeryInfo from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/info/SelectedSurgeryInfo.vue";
import ActionsMsgRow from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/ActionsMsgRow.vue";
import AdditionalPlannedSurgeryCode from "@/components/Popups/AdditionalPlannedSurgeryCode.vue";
import AdditionalSurgeryCodesPrompt from "@/components/Popups/AdditionalSurgeryCodesPrompt.vue";
import Cleave from "vue-cleave-component";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import {
  DEFAULT_OPTIONS_LIMIT,
  SEARCH_OPTIONS_LIMIT,
  filterTypeheadOptions
} from "@/utilities/typehead-search.js";

// Constants
const MOBILE_BREAKPOINT = 1200;

// Hospital codes that, when present on the surgery, should prompt
// the doctor to confirm whether related sub-procedures were also performed.
const TRIGGER_HOSPITAL_CODES = ["701", "703", "702.2", "702.3", "702.4", "750"];

// Sub-procedure codes offered for confirmation when one of the
// TRIGGER_HOSPITAL_CODES is present. `label` is the description shown to
// the doctor in the confirmation popup.
const ADDITIONAL_CODE_SUGGESTIONS = [
  { code: "734", label: "סגירת אוזנית במהלך ניתוח לב" },
  { code: "702.5", label: "החלפת/ תיקון מסתם פולמונרי" }
];

// Clinical (ICD9) code used for an accepted additional code whenever the
// hospital code has no single unambiguous clinical match - the doctor is not
// asked to pick one, so the popup can no longer resolve the ambiguity
const FALLBACK_CLINICAL_CODE = "3526";

export default {
  name: "SelectedSurgery",
  components: {
    Tags,
    ActionsMsgRow,
    SelectedSurgeryInfo,
    Cleave,
    Multiselect
  },
  data() {
    return {
      isOpen: true,
      isMobile: window.innerWidth < MOBILE_BREAKPOINT,
      // Options
      surgery_categories: [],
      surgery_codes: [],
      surgery_codes_auto: [],
      surgery_codes_clinic: [],
      surgery_codes_clinic_auto: [],
      doctorHistory: null,
      // Current surgery form data
      surg_info: {
        is_primary: "primary",
        side: "",
        // category: "",
        code_name_hospital: "",
        code_name_clinical: "",
        duration: "",
        default_surgery_duration: ""
      },
      // Tracks if fields were auto-filled and should be disabled
      disabledByAutocomplete: {
        clinical: false,
        hospital: false
      },
      // Cleave.js options for time input formatting
      options: {
        time: true,
        timePattern: ["h", "m"]
      },
      // Typeahead dropdown limits
      limit: {
        current_surgery: DEFAULT_OPTIONS_LIMIT,
        current_procedure: DEFAULT_OPTIONS_LIMIT
      },
      // Text typed in each typeahead, filtering is done by this component
      searchQuery: {
        current_surgery: "",
        current_procedure: ""
      },
      // Error messages
      errorMessage: "יש למלא את כל השדות",
      showErrorMessage: false,
      // Edit state
      editRowIndex: null,
      skipAutocomplete: false,
      skipAdditionalCodePromptOnce: false,
      // Prevents re-prompting for the additional (sub-procedure) codes on
      // every "next step" click within the same surgery creation/edit session
      additionalCodesPromptShown: false
    };
  },
  computed: {
    ...mapState("Surgery", {
      surgery: state => state.surgery,
      insuranceSurgeryTemp: state => state.insuranceSurgeryTemp,
      isInsuranceRowsLoading: state => state.isInsuranceRowsLoading,
      insuranceForm: state => state.insuranceForm,
      insuranceTypes: state => state.insuranceTypes
    }),
    ...mapGetters(["activeDoctor"]),
    ...mapGetters("Surgery", ["isPayTypeCareService", "getInsuranceByName"]),

    bothSurgeryCodesSelected() {
      return Boolean(
        this.surg_info.code_name_hospital && this.surg_info.code_name_clinical
      );
    },

    /** Hospital codes matching the search, ordered by relevance */
    filteredHospitalCodes() {
      const options = this.surgery_codes_auto.length
        ? this.surgery_codes_auto
        : this.surgery_codes;
      return filterTypeheadOptions(options, this.searchQuery.current_surgery);
    },

    /** Clinical codes matching the search, ordered by relevance */
    filteredClinicalCodes() {
      const options = this.surgery_codes_clinic_auto.length
        ? this.surgery_codes_clinic_auto
        : this.surgery_codes_clinic;
      return filterTypeheadOptions(options, this.searchQuery.current_procedure);
    }
  },
  methods: {
    ...mapMutations("Surgery", [
      "SET_SURGERY",
      "SET_INSURANCE_SURGERY_TEMP",
      "UPDATE_INSURANCE_SURGERY_TEMP_ITEM"
    ]),
    ...mapActions("Surgery", ["setInsuranceCode"]),

    /**
     * Moves a surgery row into edit mode by removing it from store
     * and populating the form with its data
     */
    editSelectedBlock(index) {
      this.skipAdditionalCodePromptOnce = true;
      if (this.editRowIndex !== null) {
        const updatedTemp = [...this.insuranceSurgeryTemp];
        updatedTemp.splice(this.editRowIndex, 1);
        this.SET_INSURANCE_SURGERY_TEMP(updatedTemp);
      }

      this.editRowIndex = index;
      this.skipAutocomplete = true;
      const object = { ...this.surgery.selected_surgery[index] };
      const updatedSurgery = [...this.surgery.selected_surgery];
      updatedSurgery.splice(index, 1);
      this.SET_SURGERY({ selected_surgery: updatedSurgery });
      this.surg_info = object;

      // Reset flag after short delay (allows watchers to detect edit mode)
      setTimeout(() => {
        this.skipAutocomplete = false;
      }, 500);
    },

    /**
     * Removes a surgery row from the selected surgeries list
     */
    removeSelectedBlock(index) {
      // Adjust edit index if removing a row before the currently edited row
      if (this.editRowIndex !== null && index < this.editRowIndex) {
        this.editRowIndex--;
      }
      const updatedSurgery = [...this.surgery.selected_surgery];
      updatedSurgery.splice(index, 1);
      this.SET_SURGERY({ selected_surgery: updatedSurgery });

      const updatedTemp = [...this.insuranceSurgeryTemp];
      updatedTemp.splice(index, 1);
      this.SET_INSURANCE_SURGERY_TEMP(updatedTemp);
    },

    onPrimary() {
      this.surg_info.is_primary =
        this.surg_info.is_primary === "primary" ? "" : "primary";
    },

    /**
     * Checks if text contains only English/ASCII characters
     * Used to determine text direction for multiselect inputs
     */
    isEnglish(text) {
      const englishRegex = /^[A-Za-z0-9\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/;
      return englishRegex.test(text);
    },

    /**
     * Clears a surgery code field and its linked autocomplete field if applicable
     */
    resetValue(type) {
      this.surg_info[type] = "";
      // Clearing hospital code always clears the linked clinical code and its options
      if (type === "code_name_hospital") {
        this.surg_info.code_name_clinical = "";
        this.surgery_codes_clinic_auto = [];
        this.disabledByAutocomplete.clinical = false;
      }
      if (
        type === "code_name_clinical" &&
        this.disabledByAutocomplete.hospital
      ) {
        this.surg_info.code_name_hospital = "";
      }
    },

    /**
     * Returns the typeahead limit based on doctor's history for a given type
     */
    limitTypehead(type) {
      const history = this.doctorHistory?.[type];
      return history?.length || DEFAULT_OPTIONS_LIMIT;
    },

    onSearch(searchValue, type) {
      this.searchQuery[type] = searchValue || "";
      this.limit[type] = this.searchQuery[type].trim()
        ? SEARCH_OPTIONS_LIMIT
        : this.limitTypehead(type);
    },

    validateObjectData(object) {
      return Boolean(object.code_name_hospital && object.code_name_clinical);
    },

    findOptionByCode(lists, codePattern, textMatch = () => true) {
      for (const list of lists) {
        const found = list.find(
          o => typeof o === "string" && codePattern.test(o) && textMatch(o)
        );
        if (found) return found;
      }
      return null;
    },

    /**
     * Extracts the leading code number from a "CODE > NAME" option string,
     * e.g. "701 > SOME NAME" -> "701".
     */
    extractCodeNumber(str) {
      if (!str) return "";
      return str.split(">")[0].trim();
    },

    /**
     * Finds the full "CODE > NAME" option for a given numeric code within
     * the currently loaded hospital-code typeahead lists.
     */
    findFullHospitalOption(code) {
      const escapedCode = code.replace(".", "\\.");
      const pattern = new RegExp(`^\\s*${escapedCode}\\s*>`);
      return this.findOptionByCode(
        [this.surgery_codes_auto, this.surgery_codes],
        pattern
      );
    },

    /**
     * Finds the full "CODE > NAME" option for a given clinical (ICD9) code
     * within the general ICD9 list - the one the clinical field itself offers.
     *
     * Deliberately not searching surgery_codes_clinic_auto: that list only
     * holds the matches of one hospital code, and the fallback code has to come
     * from the general list regardless of what a hospital code returned.
     */
    findFullClinicalOption(code) {
      const escapedCode = code.replace(".", "\\.");
      const pattern = new RegExp(`^\\s*${escapedCode}\\s*>`);
      return this.findOptionByCode([this.surgery_codes_clinic], pattern);
    },

    async fetchSurgeryDurationForHospital(val) {
      if (!val) return;
      try {
        const durationRes = await this.$API.getTypehead(
          "surgery_duration",
          null,
          null,
          this.activeDoctor.license,
          val
        );
        if (durationRes) {
          const time = this.$moment(durationRes, "H:mm").format("HH:mm");
          this.surg_info.default_surgery_duration = time;
          this.surg_info.duration = time;
          this.$emit("resetForm");
        }
      } catch (error) {
        console.error("Failed to fetch surgery duration:", error);
      }
    },

    /**
     * Shows/hides the error message for empty surgery selection
     * Called from parent component during validation
     */
    setError(show) {
      this.showErrorMessage = show;
      if (show) this.isOpen = true;
    },

    /**
     * Shows the additional planned surgery code prompt
     */
    maybeShowAdditionalCodePrompt() {
      if (this.surgery.payment_token) return;
      if (this.skipAdditionalCodePromptOnce) {
        this.skipAdditionalCodePromptOnce = false;
        return;
      }

      this.$modal.show(AdditionalPlannedSurgeryCode, {
        title: "האם יש קוד נוסף בניתוח המתוכנן?",
        content: "",
        onYes: async () => {
          const ok = await this.addBlock();
          if (ok) this.focusFirstSurgeryRowControl();
          return ok;
        }
      });
    },

    /**
     * Checks whether one of the TRIGGER_HOSPITAL_CODES is present among the
     * surgery's selected codes and, if so, shows a popup asking the doctor
     * to confirm whether the related sub-procedure codes
     * (ADDITIONAL_CODE_SUGGESTIONS) should also be added to the codes list.
     * Called by the parent step before moving on to the next step.
     *
     * Every suggestion is resolved (clinical code + duration) BEFORE the popup
     * opens, so an accepted code is complete without asking the doctor for
     * anything beyond the accept/reject answer.
     * @returns {Promise<void>} resolves once the popup has been answered
     * (saved) or dismissed - navigation to the next step is never blocked.
     */
    async maybeShowAdditionalPlannedCodesPrompt() {
      if (this.surgery.payment_token || this.additionalCodesPromptShown) return;

      const selectedCodes = this.surgery.selected_surgery.map(s =>
        this.extractCodeNumber(s.code_name_hospital)
      );

      const hasTriggerCode = selectedCodes.some(code =>
        TRIGGER_HOSPITAL_CODES.includes(code)
      );
      if (!hasTriggerCode) return;

      // Hide suggestions for codes already present in the codes list, or
      // missing from the loaded hospital-code lists (nothing to add).
      const candidates = ADDITIONAL_CODE_SUGGESTIONS.map(suggestion => ({
        ...suggestion,
        fullOption: this.findFullHospitalOption(suggestion.code)
      })).filter(
        suggestion =>
          !selectedCodes.includes(suggestion.code) && suggestion.fullOption
      );

      if (!candidates.length) return;

      // The clinical code and the duration are resolved here, before the popup
      // opens, and are not shown for editing - the popup only asks whether the
      // code should be added.
      const rows = await Promise.all(
        candidates.map(async candidate => {
          const resolved = await this.resolveAdditionalCode(
            candidate.fullOption
          );
          return {
            ...candidate,
            code_name_clinical: resolved.code_name_clinical,
            duration: resolved.duration
          };
        })
      );

      this.additionalCodesPromptShown = true;
      return new Promise(resolve => {
        this.$modal.show(
          AdditionalSurgeryCodesPrompt,
          {
            rows,
            onSave: answers => this.applyAdditionalCodeAnswers(answers)
          },
          {},
          { closed: () => resolve() }
        );
      });
    },

    /**
     * Resolves the clinical (ICD9) code and default surgery duration for a
     * given hospital code option, the same way they get resolved when a
     * doctor selects a hospital code manually.
     *
     * Both are filled in automatically here and are not editable in the popup,
     * so each one has a fallback: FALLBACK_CLINICAL_CODE when the clinical
     * match is not unambiguous, and the already-planned duration when the
     * hospital code has no stored default.
     */
    async resolveAdditionalCode(fullHospitalOption) {
      const code = fullHospitalOption.split(">")[0].replace(/\s/g, "");
      let clinical = "";
      let duration = "";

      try {
        const res = await this.$API.getAutocompleteSurgCode(
          "tafnit_to_chameleon",
          code
        );
        const clinicalOptions = res?.map(item => item.name) ?? [];

        // Only a single match is unambiguous - with none or several the
        // fallback code below is used instead
        if (clinicalOptions.length === 1) clinical = clinicalOptions[0];
      } catch (error) {
        console.error(
          "Failed to autocomplete clinical code for additional surgery code:",
          error
        );
      }

      // Anything other than a single match (none, or several) falls back to the
      // fixed code, taken in full ("CODE > NAME") from the general ICD9 list -
      // exactly as a manually picked option would be
      if (!clinical) {
        clinical = this.findFullClinicalOption(FALLBACK_CLINICAL_CODE) || "";
        if (!clinical) {
          console.warn(
            `Clinical code ${FALLBACK_CLINICAL_CODE} was not found in the general ICD9 list`
          );
        }
      }

      try {
        const durationRes = await this.$API.getTypehead(
          "surgery_duration",
          null,
          null,
          this.activeDoctor.license,
          fullHospitalOption
        );
        if (durationRes) {
          duration = this.$moment(durationRes, "H:mm").format("HH:mm");
        }
      } catch (error) {
        console.error(
          "Failed to fetch duration for additional surgery code:",
          error
        );
      }

      if (!duration) duration = this.plannedSurgeryDuration();

      return {
        code_name_hospital: fullHospitalOption,
        code_name_clinical: clinical,
        duration
      };
    },

    /**
     * Duration to fall back on when the additional code has no stored default:
     * the one already planned for this surgery (the primary row first). The
     * doctor confirmed the code, so adding it with the surgery's own duration
     * beats dropping it over a missing field.
     */
    plannedSurgeryDuration() {
      const rows = this.surgery.selected_surgery || [];
      const durationOf = row => row.duration || row.default_surgery_duration;
      const primary = rows.find(row => row.is_primary && durationOf(row));
      const anyRow = primary || rows.find(durationOf);
      return anyRow ? durationOf(anyRow) : "";
    },

    /**
     * Adds the accepted additional codes to the surgery's codes list.
     *
     * A "פרטי ניתוח מתוכנן" row requires the hospital code, the clinical
     * (ICD9) code AND the duration to be filled. All three are already present
     * on the answered rows: the hospital code comes from the suggestion, while
     * the clinical code and the duration are resolved automatically before the
     * popup opens (each with its own fallback). The completeness check below is
     * a safety net, not the expected path.
     */
    async applyAdditionalCodeAnswers(answers) {
      const accepted = answers.filter(a => a.answer === "accept");
      if (!accepted.length) return;

      const resolvedRows = [];
      for (const item of accepted) {
        const missing = [
          !item.fullOption && "code_name_hospital",
          !item.code_name_clinical && "code_name_clinical",
          !item.duration && "duration"
        ].filter(Boolean);
        if (missing.length) {
          console.warn(
            `Additional surgery code ${
              item.code
            } is incomplete (missing: ${missing.join(", ")}) and was not added`
          );
          continue;
        }
        resolvedRows.push({
          is_primary: "",
          side: "",
          code_name_hospital: item.fullOption,
          code_name_clinical: item.code_name_clinical,
          duration: item.duration,
          default_surgery_duration: item.duration
        });
      }

      if (!resolvedRows.length) return;

      const updatedSurgery = [
        ...this.surgery.selected_surgery.map(s => ({ ...s })),
        ...resolvedRows
      ];
      this.SET_SURGERY({ selected_surgery: updatedSurgery });

      // Keep insuranceSurgeryTemp aligned by index with selected_surgery
      const updatedTemp = [...this.insuranceSurgeryTemp];
      const firstAddedIndex = updatedTemp.length;
      resolvedRows.forEach(row => {
        updatedTemp.push({ code_name_hospital: row.code_name_hospital });
      });
      this.SET_INSURANCE_SURGERY_TEMP(updatedTemp);

      await this.resolveInsuranceCodesForAddedRows(
        firstAddedIndex,
        resolvedRows.length
      );
    },

    /**
     * Resolves the insurer's surgery codes ("שם/קוד ניתוח של המבטח") for rows
     * added from the popup, the same way the hospital-code watcher does when a
     * doctor picks a code manually - otherwise those rows reach the insurance
     * step with an empty insurer code list.
     *
     * Uses insuranceForm.payType exactly like the manual flow, so both paths
     * resolve against the same insurance. The RHINOPLASTY special case is not
     * handled here because the suggested codes are a fixed list that never
     * includes it.
     * @param {number} firstIndex index in insuranceSurgeryTemp of the first
     * added row
     * @param {number} count how many rows were added
     */
    async resolveInsuranceCodesForAddedRows(firstIndex, count) {
      const selectedInsurance = this.getInsuranceByName(
        this.insuranceForm.payType
      );
      if (!selectedInsurance) return;

      const insuranceId = parseInt(selectedInsurance.insurance_code);
      await Promise.all(
        Array.from({ length: count }, (_, i) =>
          this.setInsuranceCode({ index: firstIndex + i, insuranceId })
        )
      );
    },

    /**
     * Focuses the first surgery row control
     */
    focusFirstSurgeryRowControl() {
      this.$nextTick(() => {
        setTimeout(() => {
          const side = this.$refs.surgerySideSelect;
          if (side && side.$el && typeof side.$el.focus === "function") {
            side.$el.focus();
          }
        }, 150);
      });
    },

    /**
     * Validates and adds the current surgery info to the selected surgeries list.
     * If editing, inserts at the original position; otherwise appends.
     * @returns {Promise<boolean>}
     */
    async addBlock() {
      const isAddFromEdit = this.editRowIndex !== null;
      this.showErrorMessage = false;

      const res = await this.$refs.end_time.validate();
      if (!res?.valid) {
        this.showErrorMessage = true;
        if (isAddFromEdit) this.editRowIndex = null;
        return false;
      }

      const object = { ...this.surg_info };
      if (!this.validateObjectData(object)) {
        this.showErrorMessage = true;
        if (isAddFromEdit) this.editRowIndex = null;
        return false;
      }

      this.$modal.hideAll();

      // Deep clone to avoid mutating store directly
      const updated = this.surgery.selected_surgery.map(s => ({ ...s }));

      // Only one surgery can be primary - clear others if this one is primary
      if (object.is_primary) {
        updated.forEach(s => (s.is_primary = ""));
      }

      if (isAddFromEdit && this.editRowIndex !== null) {
        updated.splice(this.editRowIndex, 0, object);
      } else {
        updated.push(object);
      }

      this.SET_SURGERY({ selected_surgery: updated });
      this.clearSurgInfoForm();
      if (isAddFromEdit) this.editRowIndex = null;
      return true;
    },

    /**
     * Clears all fields in the surgery info form
     */
    clearSurgInfoForm() {
      Object.keys(this.surg_info).forEach(key => {
        this.surg_info[key] = "";
      });
    },

    /**
     * Clears the edit row state and form
     */
    clearEditRow() {
      this.clearSurgInfoForm();
      this.editRowIndex = null;
    },

    /**
     * Formats Cleave.js time input into HH:mm format
     */
    onCleave(value) {
      if (value) {
        this.surg_info.duration = `${value.substring(0, 2)}:${value.substring(
          2
        )}`;
      } else {
        this.surg_info.duration = value;
      }
    },

    /**
     * Prepends doctor's history items to the typeahead options
     */
    getTypeheadHistory(resArr, type) {
      const history = this.doctorHistory?.[type];
      if (!history?.length) return resArr;
      return [...history, ...resArr];
    },

    /**
     * Fetches doctor's surgery history and populates typeahead options
     */
    async getHistory() {
      if (!this.activeDoctor?.id) return;

      try {
        const resHistory = await this.$API.getDoctorHistory(
          this.activeDoctor.id
        );
        if (resHistory) this.doctorHistory = resHistory;

        // Fetch typeahead options in parallel
        const [surgeryRes, procedureRes] = await Promise.all([
          this.$API.getTypehead("current_surgery"),
          this.$API.getTypehead("current_new_procedure")
        ]);

        // Process surgery codes (hospital)
        const surgeryTmp = surgeryRes.map(r => r.surgery_eng_name);
        this.surgery_codes = [
          ...new Set(this.getTypeheadHistory(surgeryTmp, "current_surgery"))
        ];

        // Process procedure codes (clinical ICD9)
        const procedureTmp = [...new Set(procedureRes.map(r => r.procedure))];
        this.surgery_codes_clinic = [
          ...new Set(this.getTypeheadHistory(procedureTmp, "current_procedure"))
        ];
      } catch (error) {
        console.error("Failed to fetch doctor history:", error);
      }
    }
  },
  watch: {
    activeDoctor: {
      handler() {
        this.getHistory();
      },
      immediate: true
    },

    bothSurgeryCodesSelected(val, prev) {
      if (!val || prev === true) return;
      this.$nextTick(() => this.maybeShowAdditionalCodePrompt());
    },

    /**
     * Watches hospital code changes to:
     * 1. Fetch and set default surgery duration
     * 2. Auto-fill clinical code if only one match exists
     * 3. Update insurance temp data for edit tracking
     * 4. Fetch insurance surgery codes if applicable
     */
    async "surg_info.code_name_hospital"(val) {
      if (!val) {
        this.disabledByAutocomplete.clinical = false;
        this.surg_info.duration = "";
        // Clean up insurance temp data
        if (
          this.insuranceSurgeryTemp?.length !==
          this.surgery.selected_surgery?.length
        ) {
          const updatedTemp = [...this.insuranceSurgeryTemp];
          if (updatedTemp[this.editRowIndex]) {
            // On edit - clear the hospital code
            updatedTemp[this.editRowIndex] = {
              ...updatedTemp[this.editRowIndex],
              code_name_hospital: ""
            };
          } else {
            // New - remove last item
            updatedTemp.pop();
          }
          this.SET_INSURANCE_SURGERY_TEMP(updatedTemp);
        }
        return;
      }

      // Track insurance data for edit operations
      let newSpecialInsuranceCode = false;
      let insuranceSurgeryIndex = this.insuranceSurgeryTemp.length;

      const updatedTemp = [...this.insuranceSurgeryTemp];
      if (updatedTemp[this.editRowIndex]) {
        // On edit - update existing item
        insuranceSurgeryIndex = this.editRowIndex;
        updatedTemp[this.editRowIndex] = {
          ...updatedTemp[this.editRowIndex],
          code_name_hospital: val
        };
      } else {
        // New - add to temp array
        const newItem = { code_name_hospital: val };

        // Handle RHINOPLASTY special case
        if (val === "1 > RHINOPLASTY") {
          newSpecialInsuranceCode = true;
          newItem.insurance_type = "פרטי";
          newItem.newSpecialInsuranceCode = true;
        }

        updatedTemp.push(newItem);
      }
      this.SET_INSURANCE_SURGERY_TEMP(updatedTemp);

      // Fetch insurance surgery codes if pay type requires it
      const payTypeForInsurance = newSpecialInsuranceCode
        ? "פרטי"
        : this.insuranceForm.payType;
      const selectedInsurance = this.getInsuranceByName(payTypeForInsurance);

      if (selectedInsurance) {
        const insuranceId = parseInt(selectedInsurance.insurance_code);
        await this.setInsuranceCode({
          index: insuranceSurgeryIndex,
          insuranceId
        });
      }

      await this.fetchSurgeryDurationForHospital(val);

      // Skip clinical code lookup if already set (unless editing)
      if (this.surg_info.code_name_clinical && !this.skipAutocomplete) return;

      // Auto-fill clinical code based on hospital code
      const code = val.split(" > ")[0].replace(/\s/g, "");
      try {
        const res = await this.$API.getAutocompleteSurgCode(
          "tafnit_to_chameleon",
          code
        );
        this.surgery_codes_clinic_auto = [];
        this.disabledByAutocomplete.clinical = false;

        if (res?.length) {
          if (this.skipAutocomplete) {
            // When editing, only disable if single match equals current value
            if (
              res.length === 1 &&
              res[0].name === this.surg_info.code_name_clinical
            ) {
              this.disabledByAutocomplete.clinical = true;
            }
            return;
          }
          if (res.length === 1) {
            this.surg_info.code_name_clinical = res[0].name;
            this.disabledByAutocomplete.clinical = true;
          } else {
            this.surgery_codes_clinic_auto = res.map(item => item.name);
          }
        }
      } catch (error) {
        console.error("Failed to autocomplete clinical code:", error);
      }
    },

    /**
     * Watches clinical code changes to auto-fill hospital code
     * when clinical code is selected first
     */
    async "surg_info.code_name_clinical"(val) {
      if (!val || this.surg_info.code_name_hospital) {
        this.disabledByAutocomplete.hospital = false;
        return;
      }

      const code = val.split(" > ")[0].replace(/\s/g, "");
      try {
        const res = await this.$API.getAutocompleteSurgCode(
          "chameleon_to_tafnit",
          code
        );
        this.surgery_codes_auto = [];
        this.disabledByAutocomplete.hospital = false;

        if (res?.length) {
          if (res.length === 1) {
            this.surg_info.code_name_hospital = res[0].name;
            this.disabledByAutocomplete.hospital = true;
          } else {
            this.surgery_codes_auto = res.map(item => item.name);
          }
        }
      } catch (error) {
        console.error("Failed to autocomplete hospital code:", error);
      }
    },

    "surg_info.duration"(val) {
      if (!val) this.surg_info.duration = "HH:mm";
    }

    // "surg_info.category"(val) {
    //   // reset
    //   this.surgery_codes = [];
    //   this.surgery_codes_auto = [];
    //   this.surgery_codes_clinic = [];
    //   this.surgery_codes_clinic_auto = [];
    //   if (!this.skipAutocomplete) {
    //     this.surg_info.code_name_clinical = "";
    //     this.surg_info.code_name_hospital = "";
    //   }

    //   if (val) {
    //     // api with category
    //     this.$API.getTypehead("current_surgery", parseInt(val)).then(res => {
    //       const tmp = res.map(r => r.surgery_eng_name);
    //       this.surgery_codes = this.getTypeheadHistory(tmp, "current_surgery");
    //     });

    //     this.$API.getTypehead("current_new_procedure", parseInt(val)).then(res => {
    //       const map = res.map(r => r.procedure);
    //       const tmp = [...new Set(map)];
    //       this.surgery_codes_clinic = this.getTypeheadHistory(
    //         tmp,
    //         "current_procedure"
    //       );
    //     });
    //   } else {
    //     // api witout category
    //     this.$API.getTypehead("current_surgery").then(res => {
    //       const tmp = res.map(r => r.surgery_eng_name);
    //       this.surgery_codes = this.getTypeheadHistory(tmp, "current_surgery");
    //     });

    //     this.$API.getTypehead("current_new_procedure").then(res => {
    //       const map = res.map(r => r.procedure);
    //       const tmp = [...new Set(map)];
    //       this.surgery_codes_clinic = this.getTypeheadHistory(
    //         tmp,
    //         "current_procedure"
    //       );
    //     });
    //   }
    // },
  },

  async mounted() {
    try {
      const res = await this.$API.getTypehead("current_surgery_category");
      this.surgery_categories = res;
    } catch (error) {
      console.error("Failed to load surgery categories:", error);
    }
  }
};
</script>
